import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CdkDragEnd, CdkDragMove, Point } from '@angular/cdk/drag-drop';

@Component({
  selector: 'sky-swipe-controller',
  templateUrl: 'swipe-controller.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkySwipeControllerComponent {
  @Input() allowSwipeUp = false;
  @Input() allowSwipeDown = false;
  @Input() allowSwipeLeft = false;
  @Input() allowSwipeRight = false;
  @Input() swipeDistance = 100;

  @Output() swiped = new EventEmitter<number>();

  onDragMove(event: CdkDragMove): void {
    // eslint-disable-next-line no-underscore-dangle
    event.source._dragRef.setFreeDragPosition(this.limitBounds(event.distance));
  }

  onDragEnded(event: CdkDragEnd): void {
    const point = this.limitBounds(event.distance);

    if (Math.abs(point.x) > this.swipeDistance || Math.abs(point.y) > this.swipeDistance) {
      this.swiped.emit(point.x);
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    event.source._dragRef.reset();
  }

  private limitBounds(point: Point): Point {
    let newPoint = point;

    if (!this.allowSwipeUp && newPoint.y < 0) {
      newPoint = { ...newPoint, y: 0 };
    }
    if (!this.allowSwipeDown && newPoint.y > 0) {
      newPoint = { ...newPoint, y: 0 };
    }
    if (!this.allowSwipeLeft && newPoint.x < 0) {
      newPoint = { ...newPoint, x: 0 };
    }
    if (!this.allowSwipeRight && newPoint.x > 0) {
      newPoint = { ...newPoint, x: 0 };
    }

    return newPoint;
  }
}
